import { render } from "./CreateCustomFieldModal.vue?vue&type=template&id=3a793f18&scoped=true"
import script from "./CreateCustomFieldModal.vue?vue&type=script&lang=js"
export * from "./CreateCustomFieldModal.vue?vue&type=script&lang=js"

import "./CreateCustomFieldModal.vue?vue&type=style&index=0&id=3a793f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a793f18"]])

export default __exports__